import { useAuth } from 'react-oidc-context';

/**
 * Há sessão? Para telas públicas que mudam de comportamento com login
 * (ex.: "Inscrever-se" leva ao login quando não há sessão).
 */
export function useIsAuthenticated(): boolean {
  return useAuth().isAuthenticated;
}
